var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("学号："+_vm._s(_vm.sno))]),_vm._v(" "),_c('h2',[_vm._v("姓名："+_vm._s(_vm.students.find(function (item) { return item.sno === Number(_vm.sno); }).sname))]),_vm._v(" "),_c('h2',[_vm._v("年龄："+_vm._s(_vm.students.find(function (item) { return item.sno === Number(_vm.sno); }).age))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76b00bdb","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Detail.vue
// module id = null
// module chunks = 